import React, { useContext, useState } from "react";
import { InputField, Button, Alert, CircularProgress } from "@mui/material";
import useAxios from "../../../hooks/useAxios";
import "./ResetPasswordForm.css";
import { AuthContext } from "../../../context/AuthContext";
import WhiteInputField from '../../common/StyledComponents/WhiteInputField/WhiteInputField';

const ResetPasswordForm = ({ setCurrentStep }) => {
  const [formData, setFormData] = useState({
    otp: "",
    new_password: "",
    new_password_confirmation: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const axiosInstance = useAxios();
  const { token, setToken } = useContext(AuthContext);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await axiosInstance.post("/reset-password", formData);
      console.log(response.data);
      setCurrentStep("login"); // Redirect back to login
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="reset-password-form" onSubmit={handleSubmit}>
      <h2 className="form-title">Reset Password</h2>
      {error && <Alert severity="error">{error}</Alert>}
      <WhiteInputField
        className="custom-text-field"
        label="Enter OTP"
        name="otp"
        value={formData.otp}
        onChange={handleChange}
        required
      />
      <WhiteInputField
        className="custom-text-field"
        label="New Password"
        type="password"
        name="new_password"
        value={formData.new_password}
        onChange={handleChange}
        required
      />
      <WhiteInputField
        className="custom-text-field"
        label="Confirm New Password"
        type="password"
        name="new_password_confirmation"
        value={formData.new_password_confirmation}
        onChange={handleChange}
        required
      />
      <Button
        type="submit"
        className="submit-button primary-button"
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Reset Password"}
      </Button>
    </form>
  );
};

export default ResetPasswordForm;
